export default class Login {
	constructor(node) {
		this.node = node;
		this.loginFormNode = this.node.querySelector('#form-login');
		this.forgottenPasswordFormNode = this.node.querySelector('#form-forgotten-password');

		this.addListeners();
	}

	static init() {
		let loginNode = document.querySelector("[data-login]");

		if (loginNode) {
			return new Login(loginNode);
		}
	}

	addListeners() {
		let _this = this;

		$(this.loginFormNode).validate({
			submitHandler: function(form, event) {
				event.preventDefault();
				_this.submitLoginForm();
			}
		});

		this.loginFormNode.querySelector('#forgotten-password-toggle').addEventListener('click', function(event) {
			event.preventDefault();

			$('#form-login').slideUp(500, 'easeInOutQuart');
			$('#form-forgotten-password').slideDown(500, 'easeInOutQuart');
		});

		$(this.forgottenPasswordFormNode).validate({
			submitHandler: function(form, event) {
				event.preventDefault();
				_this.submitForgottenPasswordForm();
			}
		});

		this.forgottenPasswordFormNode.querySelector('#annulla-forgot-password').addEventListener('click', function(event) {
			event.preventDefault();

			$('#form-login').slideDown(500, 'easeInOutQuart');
			$('#form-forgotten-password').slideUp(500, 'easeInOutQuart');
		});
	}

	submitForgottenPasswordForm() {
		var _this = this;
		var responseData = {};

		this.forgottenPasswordFormNode.classList.add('busy');

		let submittedData = {
			email: this.forgottenPasswordFormNode.querySelector('input[name="Email"]').value
		};

		$.ajax({
			type: "POST",
			url: this.forgottenPasswordFormNode.getAttribute('action'),
			cache: false,
			contentType: "application/json; charset=utf-8",
			data: JSON.stringify(submittedData),
			dataType: "json",
			success: function(data) {
				responseData = data;

				_this.forgottenPasswordFormNode.querySelector('.success-msg').innerHTML = "";
				_this.forgottenPasswordFormNode.querySelector('.error-msg').innerHTML = "";

				if (responseData.d.Status === true) {
					_this.forgottenPasswordFormNode.querySelector('.success-msg').innerHTML = '<span>' + responseData.d.HTML + '</span>';
				} else {
					_this.forgottenPasswordFormNode.querySelector('.error-msg').innerHTML = '<span>' + responseData.d.HTML + '</span>';
				}
			},
			error: function(data) {
				responseData = data;
			},
			complete: function() {
				// console.log(responseData);

				_this.forgottenPasswordFormNode.classList.remove('busy');
			}
		});
	}

	submitLoginForm() {
		var _this = this;
		var responseData = {};

		this.loginFormNode.classList.add('busy');

		let submittedData = {
			email: this.loginFormNode.querySelector('input[name="Email"]').value,
			password: this.loginFormNode.querySelector('input[name="Password"]').value
		};

		$.ajax({
			type: "POST",
			url: this.loginFormNode.getAttribute('action'),
			cache: false,
			contentType: "application/json; charset=utf-8",
			data: JSON.stringify(submittedData),
			dataType: "json",
			success: function(data) {
				responseData = data;

				if (responseData.d.Status === true) {
					location.reload();
				} else {
					_this.loginFormNode.querySelector('.error-msg').innerHTML = '<span>' + responseData.d.HTML + '</span>';
				}
			},
			error: function(data) {
				responseData = data;
			},
			complete: function() {
				// console.log(responseData);

				_this.loginFormNode.classList.remove('busy');
			}
		});
	}
}
